import type { CategoryTree } from "../models/category";
import { categoryTreeMind } from "./treeMind";
import { categoryTreeWorld } from "./treeWorld";

export const categoryTree: CategoryTree = { ...categoryTreeMind, ...categoryTreeWorld };
